var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { LoadingStateDefaults, LoadingStateModifiers } from "./loadingstate";
var delayForLoadingTooLong_ms = 500;
function createLoadingStateGetter(loadingStateGetter) {
    return loadingStateGetter !== null && loadingStateGetter !== void 0 ? loadingStateGetter : (function (draft) { return draft; });
}
var loadImmediate = function (store, loader, stateProducer, loadingStateGetter) {
    return __awaiter(this, void 0, void 0, function () {
        var getLoadingState, resolve, promise;
        return __generator(this, function (_a) {
            getLoadingState = createLoadingStateGetter(loadingStateGetter);
            store.setState(function (draft) { return LoadingStateModifiers.startLoading(getLoadingState(draft)); });
            setTimeout(function () { return store.setState(function (draft) { return LoadingStateModifiers.setLoadingTooLongIfLoading(getLoadingState(draft)); }); }, delayForLoadingTooLong_ms);
            resolve = function (success, response) {
                var _a = getLoadingState(store.getState()), loadQueued = _a.loadQueued, loader = _a.loader;
                if (loadQueued) {
                    store.setState(function (draft) {
                        var loadingState = getLoadingState(draft);
                        loadingState.loadQueued = false;
                        loadingState.loader = null;
                    });
                    setTimeout(function () {
                        loadImmediate(store, loader, stateProducer, loadingStateGetter);
                        store.setState(function (draft) { return LoadingStateModifiers.stopLoading(getLoadingState(draft), success); });
                    }, 0);
                }
                else {
                    stateProducer(store, response.data, response);
                    store.setState(function (draft) { return LoadingStateModifiers.stopLoading(getLoadingState(draft), success); });
                }
            };
            promise = loader();
            return [2 /*return*/, promise.then(function (success) { return resolve(true, success); }, function (failure) { return resolve(false, failure); })];
        });
    });
};
var load = function (store, loader, stateProducer, loadingStateGetter) {
    return __awaiter(this, void 0, void 0, function () {
        var getLoadingState, loading;
        return __generator(this, function (_a) {
            getLoadingState = createLoadingStateGetter(loadingStateGetter);
            loading = getLoadingState(store.getState()).loading;
            if (!loading) {
                loadImmediate(store, loader, stateProducer, loadingStateGetter);
            }
            return [2 /*return*/];
        });
    });
};
var loadLast = function (store, loader, stateProducer, loadingStateGetter) {
    return __awaiter(this, void 0, void 0, function () {
        var getLoadingState, loading;
        return __generator(this, function (_a) {
            getLoadingState = createLoadingStateGetter(loadingStateGetter);
            loading = getLoadingState(store.getState()).loading;
            if (loading) {
                store.setState(function (draft) {
                    var loadingState = getLoadingState(draft);
                    loadingState.loadQueued = true;
                    loadingState.loader = loader;
                });
            }
            else {
                loadImmediate(store, loader, stateProducer, loadingStateGetter);
            }
            return [2 /*return*/];
        });
    });
};
var loadAll = function (store, loader, stateProducer, loadingStateGetter) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            loadImmediate(store, loader, stateProducer, loadingStateGetter);
            return [2 /*return*/];
        });
    });
};
var update = function (store, updater, stateProducer, loadingStateGetter) {
    return __awaiter(this, void 0, void 0, function () {
        var getLoadingState, updating, resolve, promise;
        return __generator(this, function (_a) {
            getLoadingState = createLoadingStateGetter(loadingStateGetter);
            updating = getLoadingState(store.getState()).updating;
            if (updating) {
                return [2 /*return*/];
            }
            store.setState(function (draft) { return LoadingStateModifiers.startUpdating(getLoadingState(draft)); });
            resolve = function (success, response) {
                stateProducer(store, response.data, response);
                store.setState(function (draft) { return LoadingStateModifiers.stopUpdating(getLoadingState(draft), success); });
            };
            promise = updater();
            return [2 /*return*/, promise.then(function (success) { return resolve(true, success); }, function (failure) { return resolve(false, failure); })];
        });
    });
};
export { load, loadLast, loadAll, LoadingStateDefaults, update, };
